export default __webpack_public_path__ + "static/media/Logo-CodeGreen.89b42675.png";